import PrivateRoute from './components/route/PrivateRoute';
import Scenarios from './pages/scenarios';
import { Routes, Route } from "react-router-dom";

const OverView = () => {
    return (
        <PrivateRoute validatorName="SCENARIO">
            <Routes>
                <Route path="/" element={<Scenarios />} />
            </Routes>
        </PrivateRoute>
    )
}

export default OverView;